import gsap from 'gsap';
import $ from 'jquery';

const heroSlider = {
    init() {
        this.startImageTransition();
    },

    startImageTransition() {
        const galleries = $('.__img_gal');
        let currentIndex = 0;
        const totalGalleries = galleries.length;
        let isVisible = true;        // Document visible
        let hasFocus = true;         // Fenêtre active
        let isInViewport = true;
        let shouldAnimate = true;
        let lastSwitch = performance.now();
        const switchInterval = 3000;
        let rafId = null;

        $(galleries[currentIndex]).addClass('active');

        function updateAnimationState() {
            const wasAnimating = shouldAnimate;
            shouldAnimate = isVisible && hasFocus && isInViewport;

            if (shouldAnimate && !wasAnimating) {
                lastSwitch = performance.now(); // évite un saut
                rafId = requestAnimationFrame(animate);
            }

            if (!shouldAnimate && rafId !== null) {
                cancelAnimationFrame(rafId);
                rafId = null;
            }
        }

        // ✅ Page visible / cachée
        document.addEventListener("visibilitychange", () => {
            isVisible = !document.hidden;
            updateAnimationState();
        });

        // ✅ Fenêtre active / inactive
        window.addEventListener("blur", () => {
            hasFocus = false;
            updateAnimationState();
        });

        window.addEventListener("focus", () => {
            hasFocus = true;
            updateAnimationState();
        });

        // ✅ Observer si le slider est dans le viewport
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                isInViewport = entry.isIntersecting;
                updateAnimationState();
            });
        }, {threshold: 0.2});

        if (galleries[0]) observer.observe(galleries[0]);

        function animate() {
            if (!shouldAnimate) return;

            const now = performance.now();
            if (now - lastSwitch >= switchInterval) {
                let prevIndex = currentIndex;
                currentIndex = (currentIndex + 1) % totalGalleries;

                const durations = [
                    (Math.random() * 0.9 + 0.7).toFixed(2),
                    (Math.random() * 0.9 + 0.6).toFixed(2),
                    (Math.random() * 0.9 + 0.6).toFixed(2),
                    (Math.random() * 0.9 + 0.4).toFixed(2)
                ];

                const oldImages = $(galleries[prevIndex]).find('img');
                const newImages = $(galleries[currentIndex]).find('img');

                oldImages.each((i, img) => {
                    gsap.to(img, {
                        top: '50%',
                        //opacity: 0,
                        duration: durations[i],
                        ease: 'power1.inOut'
                    });
                });

                gsap.to(galleries[prevIndex], {
                    top: '70%',
                    duration: 1.2,
                    //delay: 0.2,
                    ease: 'power1.inOut',
                    onComplete: () => {
                        $(galleries[prevIndex]).removeClass('active');
                    }
                });

                $(galleries[currentIndex]).addClass('active');

                newImages.each((i, img) => {
                    gsap.fromTo(img,
                        {top: '-50%', opacity: 1},
                        {top: '0%', opacity: 1, duration: durations[i], ease: 'power1.inOut'}
                    );
                });

                //, opacity: 0
                gsap.fromTo(galleries[currentIndex],
                    {top: '-70%'},
                    {top: '0%', opacity: 1, duration: 1, ease: 'power1.inOut'}
                );

                lastSwitch = now;
            }

            rafId = requestAnimationFrame(animate);
        }

        rafId = requestAnimationFrame(animate);
    }


};

export default heroSlider;
